import { render, staticRenderFns } from "./index.vue?vue&type=template&id=753b0a1d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=753b0a1d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753b0a1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('753b0a1d')) {
      api.createRecord('753b0a1d', component.options)
    } else {
      api.reload('753b0a1d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=753b0a1d&scoped=true", function () {
      api.rerender('753b0a1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/product-details/index.vue"
export default component.exports